// extracted by mini-css-extract-plugin
export default {"body_open":"bodywapper_body_open__Lk06Q","body_close":"bodywapper_body_close__Q07wR"};